// Info: Import React Dependancies
import React, { useState, useEffect } from 'react';
import { useAxios } from '../services/axiosInterceptor'

import {useDispatch, useSelector } from "react-redux";
import { GoogleReCaptcha, GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { getAppSettings, getAuthToken } from '../store/sitecoreSlice';
import Chat from './Chat';
import { useProxyServices } from '../services/useProxyService';

const ReCaptchaPageContent = () => {  
  const [isVerified, setIsVerified] = useState(false);
  const appSettings = useSelector(getAppSettings);  
  const {authenticationApi} = useAxios();
  const verifyCaptcha = async (token: string) => {
    try {
       //console.log('token',token);
      const response = await fetch(
         //'http://localhost:8081/application/chatbot-service/v1/captcha/verify',
        `${appSettings.applicationBaseUrl}${appSettings.captchaAPI}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CAPTCHA-TOKEN": token,
          },
        }
      );
      const result = await response.json();
      //console.log("Captcha verification result:", result);
      // Assuming a successful response sets verification status
      if (result) setIsVerified(true);
    } catch (error) {
      //console.error("Captcha verification failed:", error);
    }
  };
  // useEffect(() => {
  //   verifyCaptcha();
  // }, []);
  if (isVerified) {
    return <Chat/>; // Render nothing until the user is verified
  }
 
  return  <GoogleReCaptcha
  onVerify={(token: string) => verifyCaptcha(token)}/>;
 };
const ReCaptcha = () => {
 // Retrieve the site key from Redux
 const appSettings = useSelector(getAppSettings);
 const siteKey = appSettings?.recaptchaSiteKey; // Adjust according to the structure of appSettings
 // If siteKey is missing, skip CAPTCHA
 const skipCaptcha = !siteKey;
 const proxyServiceApi = useProxyServices()
 const authToken = useSelector(getAuthToken)

 useEffect(() => {
  if (!authToken || authToken === '') {
    proxyServiceApi.getUnAuthToken()
  }
 }, [authToken])
 // If siteKey exists, render CAPTCHA; otherwise, directly render Chat

 if (skipCaptcha) {
   //console.log("Site key is missing, skipping CAPTCHA.");
   return <Chat />;
 }
 return (
<GoogleReCaptchaProvider reCaptchaKey={siteKey}>
<ReCaptchaPageContent />
</GoogleReCaptchaProvider>
 );
};
export default ReCaptcha;


